import React, { useEffect, useState } from "react";
import axios from "axios";
import { API, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CreditCard, Loader2 } from "lucide-react";

const loadScript = () => new Promise((resolve) => {
  if (window.Razorpay) { resolve(true); return; }
  const s = document.createElement("script");
  s.src = "https://checkout.razorpay.com/v1/checkout.js";
  s.onload = () => resolve(true); s.onerror = () => resolve(false);
  document.body.appendChild(s);
});

export const useRazorpayEnabled = () => {
  const [on, setOn] = useState(false);
  useEffect(() => { axios.get(`${API}/public/razorpay-config`).then((r) => setOn(r.data.enabled)).catch(() => {}); }, []);
  return on;
};

// token: bearer token for the payer; body: { kind, amount?, application_id? }
export const RazorpayButton = ({ token, body, label = "Pay online", onPaid, testid = "razorpay-pay-btn", className = "" }) => {
  const enabled = useRazorpayEnabled();
  const [busy, setBusy] = useState(false);
  if (!enabled) return null;
  const pay = async () => {
    setBusy(true);
    try {
      if (!(await loadScript())) { toast.error("Could not load Razorpay. Check your internet."); return; }
      const h = { headers: { Authorization: `Bearer ${token}` } };
      const { data: o } = await axios.post(`${API}/razorpay/order`, body, h);
      const rzp = new window.Razorpay({
        key: o.key_id, order_id: o.order_id, amount: o.amount, currency: "INR",
        name: "Bengal Umrah House Travels", description: o.label,
        prefill: { name: o.name, contact: o.phone }, theme: { color: "#D4AF37" },
        handler: async (res) => {
          try { await axios.post(`${API}/razorpay/verify`, res); toast.success("Payment successful — JazakAllah khair"); onPaid && onPaid(); }
          catch (err) { toast.error(apiError(err.response?.data?.detail)); }
        },
      });
      rzp.on("payment.failed", (r) => toast.error(r.error?.description || "Payment failed"));
      rzp.open();
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <Button type="button" onClick={pay} disabled={busy} data-testid={testid} className={`bg-emerald-500 hover:bg-emerald-500/90 text-white font-semibold gap-1.5 ${className}`}>
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <CreditCard className="w-4 h-4" />} {label}
    </Button>
  );
};
